import { Base, Component, Watch } from '@/vue-property-decorator'
import {
  ChannelStatusList,
  ChannelTypeList,
  DownloadRewards,
  NeedExcludeChannelCid,
  ViewDownloadList
} from '@/views/channel/const'
import { apiGetChannelInfoById } from '@/api/channel/index'
import { getSearchParamsAndTransformObjectByURL } from '@/utils/Tool'
import { useChannelStore } from '@/views/channel/store'
import { useMainStore } from '@/store/index'
import { windowConfig } from '@/utils/window'
import Render from '@/components/business-components/func-render/async-component'

/**弹出创建h5桌面快捷方式和app下载弹出框，通过渠道配置 */
@Component<DownloadAppAndSaveShortcutByChannel>({
  name: 'DownloadAppAndSaveShortcutByChannel',
  components: {
    SaveShortcutByChannel: Render.createAsyncComponent({
      component: () =>
        import(
          '@/layouts/components/saveShortcut/components/save-shortcut-by-channel'
        )
    }),
    DownloadAppByChannel: Render.createAsyncComponent({
      component: () =>
        import('@/layouts/components/downloadApp/download-app-by-channel')
    }),

    DownloadAppByP2a: Render.createAsyncComponent({
      component: () =>
        import('@/layouts/components/downloadApp/download-app-by-p2a')
    })
  }
})
export default class DownloadAppAndSaveShortcutByChannel extends Base {
  created() {
    DownloadAppAndSaveShortcutByChannel.updateChannelInfoFromCid()
  }

  /**是否展示保持桌面快捷方式 */
  private get isShowSaveShortcut() {
    const { channelInfo } = useChannelStore()
    if (!channelInfo) {
      return false
    }
    const { downloadDisplay, viewDownload } = channelInfo
    const { Open } = ChannelStatusList
    const { H5 } = ViewDownloadList
    const showCondition = downloadDisplay === Open && viewDownload === H5
    return showCondition
  }

  /**是否展示app下载弹出框 */
  private get isShowDownloadApp() {
    const { channelInfo } = useChannelStore()
    if (!channelInfo) {
      return false
    }
    const { downloadDisplay, viewDownload } = channelInfo
    const { Open } = ChannelStatusList
    const { APP } = ViewDownloadList
    const showCondition = downloadDisplay === Open && viewDownload === APP
    return showCondition
  }

  /**是否显示p2a弹出框 */
  private get isShowP2a() {
    const { channelInfo } = useChannelStore()
    if (!channelInfo) {
      return false
    }
    const { type } = channelInfo
    const showCondition = type === ChannelTypeList.Pwa2App
    return showCondition
  }

  /**获取渠道cid通过url地址栏 */
  private static get getCidFromUrl(): string {
    const { cid } = getSearchParamsAndTransformObjectByURL()
    return cid
  }

  /**
   * 如果地址栏中带有cid，那么更新渠道信息
   */
  private static updateChannelInfoFromCid() {
    const cidFromUrl = DownloadAppAndSaveShortcutByChannel.getCidFromUrl
    if (cidFromUrl && Number(cidFromUrl)) {
      this.initChannelInfoByUrlCid(Number(cidFromUrl))
    }
  }

  /**获取注册账号的cid */
  private get cid() {
    const { userInfos } = useMainStore()
    if (!userInfos) {
      return ''
    }
    const { regPkgId } = userInfos
    return regPkgId
  }

  /**根据url的cid获取渠道该渠道相关信息 */
  private static async initChannelInfoByUrlCid(cid: number) {
    if (windowConfig.speedPackageConfig) {
      return
    }
    const channelInfo = await apiGetChannelInfoById({ id: cid })
    if (!channelInfo) {
      return
    }
    const { setChannelInfoFromUrl } = useChannelStore()
    /**获取url上面的cid只获取关于弹出的判断条件，将奖励下掉 */
    setChannelInfoFromUrl({
      ...channelInfo,
      downloadRewards: DownloadRewards.Close,
      rewardsAmount: 0
    })
  }

  /**根据注册的cid获取渠道该渠道相关信息 */
  private async initChannelInfoByRegisterCid() {
    const cid = this.cid
    if (windowConfig.speedPackageConfig) {
      return
    }
    const channelInfo = await apiGetChannelInfoById({ id: Number(cid) })
    if (!channelInfo) {
      return
    }
    const { setChannelInfoFromRegister } = useChannelStore()
    setChannelInfoFromRegister(channelInfo)
  }

  /**如果登录后，存在cid，那么渲染更新渠道信息 */
  @Watch('cid', { immediate: true })
  updateChannelInfo() {
    const cid = this.cid
    if (!cid || !Number(cid)) {
      return
    }
    if (NeedExcludeChannelCid.includes(cid)) {
      return
    }
    this.initChannelInfoByRegisterCid()
  }

  render() {
    return (
      <template>
        {this.isShowSaveShortcut && <save-shortcut-by-channel />}
        {this.isShowDownloadApp && <download-app-by-channel />}
        {this.isShowP2a && <download-app-by-p2a />}
      </template>
    )
  }
}
